import { Body, BodySmall } from "@components/Typography";
import { ShareGoalInviteStatus as InviteStatus } from "@ctypes";
import { useModal } from "@hooks";
import { i18n, Translations } from "@i18n";
import { CancelInviteModal } from "@routes/ShareGoalRoute/InviteContactList/CancelInviteModal";
import { formatPhoneNumber } from "@utils";
import { icon, label } from "./content";
import { RemoveInviteCTA } from "./RemoveInviteCTA";
import { ResendInviteCTA } from "./ResendInviteCTA";
import { useStyles } from "./styles";
import { InviteContactItemProps } from "./types";

export const InviteContactItem = ({
  status,
  phoneNumber: phoneNumberFromProp,
  id,
  goalId,
}: InviteContactItemProps) => {
  const { show } = useModal();
  const styles = useStyles();

  const phoneNumber = formatPhoneNumber(phoneNumberFromProp);

  const shouldDisplayCancel = status === InviteStatus.Pending;
  const shouldDisplayResend = [InviteStatus.Pending, InviteStatus.Expired].includes(status);
  const shouldDisplayRemove = status === InviteStatus.Rejected;

  const handleCancel = () => {
    show(<CancelInviteModal phoneNumber={phoneNumber} id={id} goalId={goalId} />);
  };

  return (
    <div style={styles.container}>
      {icon[status]}
      <div style={styles.contact}>
        <Body>{phoneNumber}</Body>
        <Body style={styles.secondary}>{label[status]}</Body>
      </div>
      <div style={styles.right}>
        {shouldDisplayCancel && (
          <div style={styles.cta} onClick={handleCancel}>
            <BodySmall style={styles.cancel}>
              {i18n.t(Translations.InviteItemCancelLabel)}
            </BodySmall>
          </div>
        )}

        {shouldDisplayRemove && <RemoveInviteCTA id={id} goalId={goalId} />}
        {shouldDisplayResend && <ResendInviteCTA id={id} />}
      </div>
    </div>
  );
};
